import React, { useState, Fragment } from "react";
import Zuck from "zuck.js";

import { client } from "helpers"
import { InboxOutlined, PlusCircleOutlined } from '@ant-design/icons';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Upload, message, Spin, Select, Button } from "antd";
import styled from "styled-components";
import { Modal, Heading, Button as CustomButton } from "components";
import { Trans, t } from "@lingui/macro"
import { country } from "App";
import { queryFetchSubjects } from "queries/data"
import { useMutation, useQuery } from "react-apollo"
import { withI18n } from "@lingui/react";
import { uploadStoriesMedia, userCreateNewStory } from "queries/stories";
import { toTimestamp } from "../../helpers";

const UploadModal = styled(Upload).attrs(() => ({
  centered: true,
  footer: false
}))`
.ant-upload.ant-upload-select {
  display: block;
}
`

const layout = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 10,
  },
};

const Drag = styled.div`
	text-align: center;
	display: block;
	padding: 2em;
	background: #f3f3f3;
	border-radius: 8px;
	> p {
		font-size: 4em;
	}
`


const AddStories = ({ i18n, showModalAddStory, setShowModalAddStory, stories, ReFetchStories, zuckStoriesApi }) => {
  const { Option } = Select;
  const [storyData, setStoryData] = useState(null);
  const [localFile, setLocalFile] = useState({ file: "", imagePreview: "" });
  const [programmeSubject, setProgrammeSubject] = useState([]);
  const [uploadStoryLoading, setUploadStoryLoading] = useState(false)

  const { loading: programmeLoading } = useQuery(queryFetchSubjects, {
    client: client.programmeClient,
    variables: { country },
    fetchPolicy: "network-only",
    onCompleted: ({ getProgrammeSubjectList }) => {
      setProgrammeSubject([...getProgrammeSubjectList])
    }
  })

  const beforeUpload = (file) => {
    handleUploadToLocal(file)
    return false;
  }

  const handleUploadToLocal = (file) => {
    const reader = new FileReader()
    reader.onloadend = () => {
      setLocalFile((prev) => ({ ...prev, file, imagePreview: reader.result }))
    }
    reader.readAsDataURL(file)
  }


  const [uploadStory] = useMutation(uploadStoriesMedia, {
    client: client.resourceClient
  })


  const [createNewStory] = useMutation(userCreateNewStory, {
    client: client.storiesClient
  })

  const handleUploadStoryMedia = async (fileUpload) => {
    try {
      if (fileUpload.type.split("/")[0] !== "image" && fileUpload.type.split("/")[0] !== "video") {
        return message.error(i18n._(t`File type unvalid !`))

      }
      if (!storyData.subjectId) {
        return message.error(i18n._(t`You need to choose subject for your story`))
      }
      setUploadStoryLoading(true)
      const res = await uploadStory({ variables: { file: fileUpload } })

      const {
        data: {
          uploadStoryMedia: {
            path: src,
            mimeType: type,
            durationSecs: length
          }
        }
      } = res;

      const story = await createNewStory({ variables: { data: { ...storyData, src, type, length } } })
      const {
        data: {
          createNewStory: newStory
        }
      } = story

      const userStory = stories[0];
      let storyZuck = Zuck.buildTimelineItem(
        userStory.name,
        zuckStoriesApi.data[0].photo,
        userStory.name,
        '',
        Date.now(userStory.lastUpdated),
        [
          ["ramon-1", newStory.fileType === "image" ? "photo" : newStory.fileType, newStory.fileType === "image" ? 3 : newStory.length, process.env.REACT_APP_S3_BACKET + "/" + process.env.REACT_APP_S3_ENV + newStory.src, process.env.REACT_APP_S3_BACKET + "/" + process.env.REACT_APP_S3_ENV + newStory.src, '', false, newStory.seen, toTimestamp(newStory.time)]
        ]
      )
      zuckStoriesApi.data[0].items.push(storyZuck.items[0])
      message.success(i18n._(t`Your story has been successfully uploaded!`))
      setUploadStoryLoading(false)
      setShowModalAddStory(false)
    } catch (err) {
      console.log(err)
      message.error(i18n._(t`There are problem in upload story!`))
      setUploadStoryLoading(false)
    }
  }
  return (
    <Modal
      title={<Trans>Upload a new story</Trans>}
      visible={showModalAddStory}
      onCancel={() => setShowModalAddStory(false)}
      footer={false}
      width="80%"
    >
      {!programmeLoading ? (<Fragment> <Form {...layout} name="control-ref">
        <Form.Item
          name="subjectId"
          label="Subject"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Select onChange={(value) => setStoryData({
            ...storyData,
            subjectId: value
          })} placeholder={"Choose Subject"}>
            {
              programmeSubject.map(prog => (
                <Option value={prog.pvid}>{prog.name}</Option>
              ))
            }
          </Select>
        </Form.Item>
      </Form>

        <UploadModal
          beforeUpload={beforeUpload}
          multiple={false}
          showUploadList={{ showPreviewIcon: true }}
        >
          <Drag>
            <p>
              <InboxOutlined />
            </p>
            <Heading
              content={<Trans>Click here or drag and drop your story</Trans>}
              subheader={<Trans>Supported formats: JPG, PNG, MP4</Trans>}
              level={4}
            />
          </Drag>
        </UploadModal>
        <CustomButton loading={uploadStoryLoading} style={{ marginTop: "1rem" }} onClick={() => handleUploadStoryMedia(localFile.file)} type="primary"> <PlusCircleOutlined style={{ fontSize: "1.1rem" }} /> Add Story</CustomButton>
      </Fragment>) : (<Spin size="large" />)
      }
    </Modal >
  );
}


export default withI18n()(AddStories);